import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DisponentOwner from '../../../../../Vessels/Single/Rows/DisponentOwner';
import { updateVesselOrder } from 'actions/vessels/orders';
import _ from 'lodash';

function DisponentWrapper({ numberOrderTable, updateVesselOrder, vesselOrder, context }) {

    const changeField = ({ value }) => {
        const newVesselOrder = _.cloneDeep(vesselOrder);
        newVesselOrder.disponentOwner = _.pick(value, ['name', '_id']);
        updateVesselOrder(numberOrderTable, newVesselOrder);
    };

    return (
        <div className='row'>
            <div className='column-left' style={{ marginTop: '25px' }}>
                Disponent owner:
            </div>
            <div className='column-right'>
                <DisponentOwner 
                    changeField={changeField}
                    disponentOwner={vesselOrder.disponentOwner}
                    confirmed={context.kind !== "broker"}
                    textFieldStyle={{ fontSize: '13px' }}
                    context={context}
                />
            </div>
        </div>
    );
}

export default connect(
    (state, ownProps) => ({
        context: state.letter.context,
        numberOrderTable: ownProps.numberOrderTable,
        vesselOrder: state.vesselOrders.items[ownProps.numberOrderTable],
    }),
    dispatch => bindActionCreators({
        updateVesselOrder,
    }, dispatch),
)(DisponentWrapper);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Vessel/Sidebar/Order/DisponentWrapper.jsx